import { ACTION_TYPES } from 'lib/Constants'

const {
    CLEAR_GROUP_NOTE_FORM,
    CLEAR_GROUP_NOTE_FORM_FIELD,
    CLEAR_GROUP_NOTE_FORM_ERROR,
    CLEAR_GROUP_NOTE_FORM_FIELD_ERROR,

    CHANGE_GROUP_NOTE_FORM_FIELD,
    CHANGE_GROUP_NOTE_FORM_FIELDS,

    VALIDATE_GROUP_NOTE_FORM,

    SAVE_GROUP_NOTE_REQUEST,
    SAVE_GROUP_NOTE_SUCCESS,
    CHANGE_ERROR
} = ACTION_TYPES

export default {
    CLEAR: CLEAR_GROUP_NOTE_FORM,
    CLEAR_ERROR: CLEAR_GROUP_NOTE_FORM_ERROR,
    CLEAR_FIELD: CLEAR_GROUP_NOTE_FORM_FIELD,
    CLEAR_FIELD_ERROR: CLEAR_GROUP_NOTE_FORM_FIELD_ERROR,
    CHANGE_FIELD: CHANGE_GROUP_NOTE_FORM_FIELD,
    CHANGE_FIELDS: CHANGE_GROUP_NOTE_FORM_FIELDS,
    VALIDATE: VALIDATE_GROUP_NOTE_FORM,
    SUBMIT_REQUEST: SAVE_GROUP_NOTE_REQUEST,
    SUBMIT_SUCCESS: SAVE_GROUP_NOTE_SUCCESS,
    SUBMIT_FAILURE: CHANGE_ERROR
}